import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

import Button from '../Button';
import Icon from '../Icon';

const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 0.0625rem solid #e5e5e5;
  height: 4rem;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-left: 1.875rem;

  @media (max-width: 800px) {
    padding-left: 1.25rem;
  }
`;

const TabContainer = styled(({active, ...props}) => props.onClick ? <Button blank {...props} /> : <Link {...props} />)`
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
  border-bottom: 0.1875rem solid ${props => props.active ? '#0049ee' : 'transparent'};
  height: 4rem;
  text-decoration: none;
  font-weight: 500;
  color: ${props => props.active ? '#0049ee' : '#747474'} !important;

  :hover {
    color: #0049ee;
  }
`;

const StyledIcon = styled(Icon)`
  margin-left: 0.5rem;
`;

function Tab({ id, menu, ...props }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setMenuOpen(prev => !prev);
  }, []);

  if (!menu) {
    return <TabContainer id={id} {...props} />;
  }

  if (!id) {
    throw new Error("Cannot use Tab menus without specifying an 'id' prop");
  }

  const clonedMenu = React.cloneElement(menu, {
    open: menuOpen,
    onClose: toggleMenu,
    relativeTo: id,
  });

  return (
    <>
      <TabContainer id={id} onClick={toggleMenu} {...props}>
        {props.children} <StyledIcon name="chevron-down" />
      </TabContainer>
      {clonedMenu}
    </>
  );
}

Tabs.Tab = Tab;
export default Tabs;